/**
 * View Cash-in cho Vietinbank / MBbank — bám `frmFuturesQryBankCashIn` (form Access).
 * Wrapper mỏng quanh `BankCashInDataSheet` để giữ chỗ riêng (storage key, sau này có thể tuỳ biến cột).
 */
import BankCashInDataSheet from './BankCashInDataSheet'
import type { BankCashInRow, BankName } from './BankCashInDialog'
import type { ReactNode } from 'react'

interface Props {
  bank: Extract<BankName, 'Vietinbank' | 'MBbank'>
  selectedKey: string | null
  onSelectionChange: (row: BankCashInRow | null) => void
  actionsSlot?: ReactNode
}

export default function FuturesBankCashInView({ bank, selectedKey, onSelectionChange, actionsSlot }: Props) {
  return (
    <BankCashInDataSheet
      bank={bank}
      columnsStorageKey="futures-cols-bank-cash-vtb-mbb-v1"
      selectedKey={selectedKey}
      onSelectionChange={onSelectionChange}
      actionsSlot={actionsSlot}
    />
  )
}
